import { BackendFetch, DevTools, FormatSimple, Tolgee } from '@tolgee/vue'

const LANGUAGE_VARIANTS = {
  en: ['en-GB', 'en-US', 'en-SA', 'en-TZ', 'en-KE', 'en-NG', 'en-CI'],
  fr: ['fr-FR', 'fr-MR'],
  ar: ['ar-SA', 'ar-EG'],
}

const queryParams = new URLSearchParams(window.location.search)
let currentLanguage =
  queryParams.get('lng') || localStorage.getItem('i18nextLng') || 'en'

if (currentLanguage.includes('-')) {
  const baseLanguage = currentLanguage.split('-')[0]
  const variants = LANGUAGE_VARIANTS[baseLanguage] || ['en']

  if (!variants.includes(currentLanguage)) {
    currentLanguage = baseLanguage
  }
}

const tolgee =
  import.meta.env.MODE === 'development'
    ? Tolgee()
        .use(DevTools())
        .use(FormatSimple())
        .init({
          language: currentLanguage,
          apiUrl: import.meta.env.VITE_APP_TOLGEE_API_URL,
          apiKey: import.meta.env.VITE_APP_TOLGEE_API_KEY,
        })
    : Tolgee()
        .use(FormatSimple())
        .use(
          BackendFetch({
            prefix:
              'https://storage.googleapis.com/tolgee-curacel-gcp/dd279e455e67259d3f8fce8d932f9b34',
          }),
        )
        .init({
          language: currentLanguage,
        })

window.tolgee = tolgee

export default tolgee
